var items = {
  "block.minecraft.air": "ilma",
  "block.minecraft.stone": "kivi",
  "block.minecraft.granite": "graniitti",
  "block.minecraft.polished_granite": "kiillotettu graniitti",
  "block.minecraft.diorite": "dioriitti",
  "block.minecraft.polished_diorite": "kiillotettu dioriitti",
  "block.minecraft.andesite": "andesiitti",
  "block.minecraft.polished_andesite": "kiillotettu andesiitti",
  "block.minecraft.grass_block": "ruohokuutio",
  "block.minecraft.dirt": "multa",
  "block.minecraft.coarse_dirt": "karkea multa",
  "block.minecraft.podzol": "podsoli",
  "block.minecraft.crimson_nylium": "karmiinisienirihmasto",
  "block.minecraft.warped_nylium": "kummasienirihmasto",
  "block.minecraft.cobblestone": "mukulakivi",
  "block.minecraft.oak_planks": "tammilankut",
  "block.minecraft.spruce_planks": "kuusilankut",
  "block.minecraft.birch_planks": "koivulankut",
  "block.minecraft.jungle_planks": "viidakkopuulankut",
  "block.minecraft.acacia_planks": "akaasialankut",
  "block.minecraft.dark_oak_planks": "tummat tammilankut",
  "block.minecraft.crimson_planks": "karmiinilankut",
  "block.minecraft.warped_planks": "kummalankut",
  "block.minecraft.oak_sapling": "tammen taimi",
  "block.minecraft.spruce_sapling": "kuusen taimi",
  "block.minecraft.birch_sapling": "koivun taimi",
  "block.minecraft.jungle_sapling": "viidakkopuun taimi",
  "block.minecraft.acacia_sapling": "akaasian taimi",
  "block.minecraft.dark_oak_sapling": "tumman tammen taimi",
  "block.minecraft.bedrock": "peruskallio",
  "block.minecraft.sand": "hiekka",
  "block.minecraft.red_sand": "punahiekka",
  "block.minecraft.gravel": "sora",
  "block.minecraft.gold_ore": "kultamalmi",
  "block.minecraft.iron_ore": "rautamalmi",
  "block.minecraft.coal_ore": "hiilimalmi",
  "block.minecraft.nether_gold_ore": "nether-kultamalmi",
  "block.minecraft.oak_log": "tammihalko",
  "block.minecraft.spruce_log": "kuusihalko",
  "block.minecraft.birch_log": "koivuhalko",
  "block.minecraft.jungle_log": "viidakkopuuhalko",
  "block.minecraft.acacia_log": "akaasiahalko",
  "block.minecraft.dark_oak_log": "tumma tammihalko",
  "block.minecraft.crimson_stem": "karmiinivarsi",
  "block.minecraft.warped_stem": "kummavarsi",
  "block.minecraft.stripped_oak_log": "kuorittu tammihalko",
  "block.minecraft.stripped_spruce_log": "kuorittu kuusihalko",
  "block.minecraft.stripped_birch_log": "kuorittu koivuhalko",
  "block.minecraft.stripped_jungle_log": "kuorittu viidakkopuuhalko",
  "block.minecraft.stripped_acacia_log": "kuorittu akaasiahalko",
  "block.minecraft.stripped_dark_oak_log": "kuorittu tumma tammihalko",
  "block.minecraft.stripped_crimson_stem": "kuorittu karmiinivarsi",
  "block.minecraft.stripped_warped_stem": "kuorittu kummavarsi",
  "block.minecraft.stripped_oak_wood": "kuorittu tammi",
  "block.minecraft.stripped_spruce_wood": "kuorittu kuusi",
  "block.minecraft.stripped_birch_wood": "kuorittu koivu",
  "block.minecraft.stripped_jungle_wood": "kuorittu viidakkopuu",
  "block.minecraft.stripped_acacia_wood": "kuorittu akaasia",
  "block.minecraft.stripped_dark_oak_wood": "kuorittu tumma tammi",
  "block.minecraft.stripped_crimson_hyphae": "kuorittu karmiinirihma",
  "block.minecraft.stripped_warped_hyphae": "kuorittu kummarihma",
  "block.minecraft.oak_wood": "tammipuu",
  "block.minecraft.spruce_wood": "kuusipuu",
  "block.minecraft.birch_wood": "koivupuu",
  "block.minecraft.jungle_wood": "viidakkopuu",
  "block.minecraft.acacia_wood": "akaasiapuu",
  "block.minecraft.dark_oak_wood": "tumma tammipuu",
  "block.minecraft.crimson_hyphae": "karmiinirihma",
  "block.minecraft.warped_hyphae": "kummarihma",
  "block.minecraft.oak_leaves": "tammenlehdet",
  "block.minecraft.spruce_leaves": "kuusenhavut",
  "block.minecraft.birch_leaves": "koivunlehdet",
  "block.minecraft.jungle_leaves": "viidakkopuunlehdet",
  "block.minecraft.acacia_leaves": "akaasianlehdet",
  "block.minecraft.dark_oak_leaves": "tumman tammenlehdet",
  "block.minecraft.sponge": "pesusieni",
  "block.minecraft.wet_sponge": "märkä pesusieni",
  "block.minecraft.glass": "lasi",
  "block.minecraft.lapis_ore": "lasuriittimalmi",
  "block.minecraft.lapis_block": "lasuriittikuutio",
  "block.minecraft.dispenser": "jakelulaite",
  "block.minecraft.sandstone": "hiekkakivi",
  "block.minecraft.chiseled_sandstone": "kaiverrettu hiekkakivi",
  "block.minecraft.cut_sandstone": "leikattu hiekkakivi",
  "block.minecraft.note_block": "sointukuutio",
  "block.minecraft.powered_rail": "kiihdytinraide",
  "block.minecraft.detector_rail": "tunnistinraide",
  "block.minecraft.sticky_piston": "tarttumamäntä",
  "block.minecraft.cobweb": "hämähäkinseitti",
  "block.minecraft.grass": "ruoho",
  "block.minecraft.fern": "saniainen",
  "block.minecraft.dead_bush": "kuollut pensas",
  "block.minecraft.seagrass": "meriruoho",
  "block.minecraft.sea_pickle": "tulitela",
  "block.minecraft.piston": "mäntä",
  "block.minecraft.white_wool": "valkoinen villa",
  "block.minecraft.orange_wool": "oranssi villa",
  "block.minecraft.magenta_wool": "purppura villa",
  "block.minecraft.light_blue_wool": "vaaleansininen villa",
  "block.minecraft.yellow_wool": "keltainen villa",
  "block.minecraft.lime_wool": "limetinvihreä villa",
  "block.minecraft.pink_wool": "vaaleanpunainen villa",
  "block.minecraft.gray_wool": "harmaa villa",
  "block.minecraft.light_gray_wool": "vaaleanharmaa villa",
  "block.minecraft.cyan_wool": "syaani villa",
  "block.minecraft.purple_wool": "violetti villa",
  "block.minecraft.blue_wool": "sininen villa",
  "block.minecraft.brown_wool": "ruskea villa",
  "block.minecraft.green_wool": "vihreä villa",
  "block.minecraft.red_wool": "punainen villa",
  "block.minecraft.black_wool": "musta villa",
  "block.minecraft.dandelion": "voikukka",
  "block.minecraft.poppy": "unikko",
  "block.minecraft.blue_orchid": "sininen orkidea",
  "block.minecraft.allium": "laukka",
  "block.minecraft.azure_bluet": "keijunsilmä",
  "block.minecraft.red_tulip": "punainen tulppaani",
  "block.minecraft.orange_tulip": "oranssi tulppaani",
  "block.minecraft.white_tulip": "valkoinen tulppaani",
  "block.minecraft.pink_tulip": "vaaleanpunainen tulppaani",
  "block.minecraft.oxeye_daisy": "päivänkakkara",
  "block.minecraft.cornflower": "ruiskaunokki",
  "block.minecraft.lily_of_the_valley": "kielo",
  "block.minecraft.wither_rose": "wither-ruusu",
  "block.minecraft.brown_mushroom": "ruskea sieni",
  "block.minecraft.red_mushroom": "kärpässieni",
  "block.minecraft.crimson_fungus": "karmiinisieni",
  "block.minecraft.warped_fungus": "kummasieni",
  "block.minecraft.crimson_roots": "karmiinijuuret",
  "block.minecraft.warped_roots": "kummajuuret",
  "block.minecraft.nether_sprouts": "nether-verso",
  "block.minecraft.weeping_vines": "itkuköynnös",
  "block.minecraft.twisting_vines": "kieroköynnös",
  "block.minecraft.sugar_cane": "sokeriruoko",
  "block.minecraft.kelp": "rakkolevä",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "kultakuutio",
  "block.minecraft.iron_block": "rautakuutio",
  "block.minecraft.oak_slab": "tammilaatta",
  "block.minecraft.spruce_slab": "kuusilaatta",
  "block.minecraft.birch_slab": "koivulaatta",
  "block.minecraft.jungle_slab": "viidakkopuulaatta",
  "block.minecraft.acacia_slab": "akaasialaatta",
  "block.minecraft.dark_oak_slab": "tumma tammilaatta",
  "block.minecraft.crimson_slab": "karmiinilaatta",
  "block.minecraft.warped_slab": "kummalaatta",
  "block.minecraft.stone_slab": "kivilaatta",
  "block.minecraft.smooth_stone_slab": "sileä kivilaatta",
  "block.minecraft.sandstone_slab": "hiekkakivilaatta",
  "block.minecraft.cut_sandstone_slab": "leikattu hiekkakivilaatta",
  "block.minecraft.petrified_oak_slab": "kivettynyt tammilaatta",
  "block.minecraft.cobblestone_slab": "mukulakivilaatta",
  "block.minecraft.brick_slab": "tiililaatta",
  "block.minecraft.stone_brick_slab": "kivitiililaatta",
  "block.minecraft.nether_brick_slab": "nether-tiililaatta",
  "block.minecraft.quartz_slab": "kvartsilaatta",
  "block.minecraft.red_sandstone_slab": "punahiekkakivilaatta",
  "block.minecraft.cut_red_sandstone_slab": "leikattu punahiekkakivilaatta",
  "block.minecraft.purpur_slab": "purpur-laatta",
  "block.minecraft.prismarine_slab": "prismariinilaatta",
  "block.minecraft.prismarine_brick_slab": "prismariinitiililaatta",
  "block.minecraft.dark_prismarine_slab": "tumma prismariinilaatta",
  "block.minecraft.smooth_quartz": "sileä kvartsikuutio",
  "block.minecraft.smooth_red_sandstone": "sileä punahiekkakivi",
  "block.minecraft.smooth_sandstone": "sileä hiekkakivi",
  "block.minecraft.smooth_stone": "sileä kivi",
  "block.minecraft.bricks": "tiili",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "kirjahylly",
  "block.minecraft.mossy_cobblestone": "sammaleinen mukulakivi",
  "block.minecraft.obsidian": "obsidiaani",
  "block.minecraft.torch": "soihtu",
  "block.minecraft.end_rod": "end-sauva",
  "block.minecraft.chorus_plant": "chorus-kasvi",
  "block.minecraft.chorus_flower": "chorus-kukka",
  "block.minecraft.purpur_block": "purpur-kuutio",
  "block.minecraft.purpur_pillar": "purpur-pilari",
  "block.minecraft.purpur_stairs": "purpur-portaat",
  "block.minecraft.spawner": "luoja",
  "block.minecraft.oak_stairs": "tammiportaat",
  "block.minecraft.chest": "arkku",
  "block.minecraft.diamond_ore": "timanttimalmi",
  "block.minecraft.diamond_block": "timanttikuutio",
  "block.minecraft.crafting_table": "työpöytä",
  "block.minecraft.farmland": "viljelysmaa",
  "block.minecraft.furnace": "uuni",
  "block.minecraft.ladder": "tikas",
  "block.minecraft.rail": "raide",
  "block.minecraft.cobblestone_stairs": "mukulakiviportaat",
  "block.minecraft.lever": "vipu",
  "block.minecraft.stone_pressure_plate": "kivipainelaatta",
  "block.minecraft.oak_pressure_plate": "tammipainelaatta",
  "block.minecraft.spruce_pressure_plate": "kuusipainelaatta",
  "block.minecraft.birch_pressure_plate": "koivupainelaatta",
  "block.minecraft.jungle_pressure_plate": "viidakkopuupainelaatta",
  "block.minecraft.acacia_pressure_plate": "akaasiapainelaatta",
  "block.minecraft.dark_oak_pressure_plate": "tumma tammipainelaatta",
  "block.minecraft.crimson_pressure_plate": "karmiinipainelaatta",
  "block.minecraft.warped_pressure_plate": "kummapainelaatta",
  "block.minecraft.polished_blackstone_pressure_plate": "kiillotettu mustakivipainelaatta",
  "block.minecraft.redstone_ore": "redstone-malmi",
  "block.minecraft.redstone_torch": "redstone-soihtu",
  "block.minecraft.snow": "lumi",
  "block.minecraft.ice": "jää",
  "block.minecraft.snow_block": "lumikuutio",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "savi",
  "block.minecraft.jukebox": "levysoitin",
  "block.minecraft.oak_fence": "tammiaita",
  "block.minecraft.spruce_fence": "kuusiaita",
  "block.minecraft.birch_fence": "koivuaita",
  "block.minecraft.jungle_fence": "viidakkopuuaita",
  "block.minecraft.acacia_fence": "akaasia-aita",
  "block.minecraft.dark_oak_fence": "tumma tammiaita",
  "block.minecraft.crimson_fence": "karmiiniaita",
  "block.minecraft.warped_fence": "kumma-aita",
  "block.minecraft.pumpkin": "kurpitsa",
  "block.minecraft.carved_pumpkin": "kaiverrettu kurpitsa",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sieluhiekka",
  "block.minecraft.soul_soil": "sielumulta",
  "block.minecraft.basalt": "basaltti",
  "block.minecraft.polished_basalt": "kiillotettu basaltti",
  "block.minecraft.soul_torch": "sielusoihtu",
  "block.minecraft.glowstone": "hehkukivi",
  "block.minecraft.jack_o_lantern": "kurpitsalyhty",
  "block.minecraft.oak_trapdoor": "tammiluukku",
  "block.minecraft.spruce_trapdoor": "kuusiluukku",
  "block.minecraft.birch_trapdoor": "koivuluukku",
  "block.minecraft.jungle_trapdoor": "viidakkopuuluukku",
  "block.minecraft.acacia_trapdoor": "akaasialuukku",
  "block.minecraft.dark_oak_trapdoor": "tumma tammiluukku",
  "block.minecraft.crimson_trapdoor": "karmiiniluukku",
  "block.minecraft.warped_trapdoor": "kummaluukku",
  "block.minecraft.infested_stone": "saastunut kivi",
  "block.minecraft.infested_cobblestone": "saastunut mukulakivi",
  "block.minecraft.infested_stone_bricks": "saastunut kivitiili",
  "block.minecraft.infested_mossy_stone_bricks": "saastunut sammalkivitiili",
  "block.minecraft.infested_cracked_stone_bricks": "saastunut murtunut kivitiili",
  "block.minecraft.infested_chiseled_stone_bricks": "saastunut kaiverrettu kivitiili",
  "block.minecraft.stone_bricks": "kivitiili",
  "block.minecraft.mossy_stone_bricks": "sammaleinen kivitiili",
  "block.minecraft.cracked_stone_bricks": "murtunut kivitiili",
  "block.minecraft.chiseled_stone_bricks": "veistetty kivitiili",
  "block.minecraft.brown_mushroom_block": "ruskea sienikuutio",
  "block.minecraft.red_mushroom_block": "kärpässienikuutio",
  "block.minecraft.mushroom_stem": "sienen varsi",
  "block.minecraft.iron_bars": "kalterit",
  "block.minecraft.chain": "ketju",
  "block.minecraft.glass_pane": "lasipaneeli",
  "block.minecraft.melon": "meloni",
  "block.minecraft.vine": "köynnös",
  "block.minecraft.oak_fence_gate": "tammiportti",
  "block.minecraft.spruce_fence_gate": "kuusiportti",
  "block.minecraft.birch_fence_gate": "koivuportti",
  "block.minecraft.jungle_fence_gate": "viidakkopuuportti",
  "block.minecraft.acacia_fence_gate": "akaasiaportti",
  "block.minecraft.dark_oak_fence_gate": "tumma tammiportti",
  "block.minecraft.crimson_fence_gate": "karmiiniportti",
  "block.minecraft.warped_fence_gate": "kummaportti",
  "block.minecraft.brick_stairs": "tiiliportaat",
  "block.minecraft.stone_brick_stairs": "kivitiiliportaat",
  "block.minecraft.mycelium": "sienirihmasto",
  "block.minecraft.lily_pad": "lumpeenlehti",
  "block.minecraft.nether_bricks": "nether-tiili",
  "block.minecraft.cracked_nether_bricks": "murtunut nether-tiili",
  "block.minecraft.chiseled_nether_bricks": "kaiverrettu nether-tiili",
  "block.minecraft.nether_brick_fence": "nether-tiiliaita",
  "block.minecraft.nether_brick_stairs": "nether-tiiliportaat",
  "block.minecraft.enchanting_table": "lumouspöytä",
  "block.minecraft.end_portal_frame": "end-portaalin kehys",
  "block.minecraft.end_stone": "end-kivi",
  "block.minecraft.end_stone_bricks": "end-kivitiili",
  "block.minecraft.dragon_egg": "lohikäärmeen muna",
  "block.minecraft.redstone_lamp": "redstone-lamppu",
  "block.minecraft.sandstone_stairs": "hiekkakiviportaat",
  "block.minecraft.emerald_ore": "smaragdimalmi",
  "block.minecraft.ender_chest": "ender-arkku",
  "block.minecraft.tripwire_hook": "ansalankakoukku",
  "block.minecraft.emerald_block": "smaragdikuutio",
  "block.minecraft.spruce_stairs": "kuusiportaat",
  "block.minecraft.birch_stairs": "koivuportaat",
  "block.minecraft.jungle_stairs": "viidakkopuuportaat",
  "block.minecraft.crimson_stairs": "karmiiniportaat",
  "block.minecraft.warped_stairs": "kummaportaat",
  "block.minecraft.command_block": "komentokuutio",
  "block.minecraft.beacon": "merkkivalo",
  "block.minecraft.cobblestone_wall": "mukulakivimuuri",
  "block.minecraft.mossy_cobblestone_wall": "sammaleinen kivimuuri",
  "block.minecraft.brick_wall": "tiilimuuri",
  "block.minecraft.prismarine_wall": "prismariinimuuri",
  "block.minecraft.red_sandstone_wall": "punahiekkakivimuuri",
  "block.minecraft.mossy_stone_brick_wall": "sammaleinen kivitiilimuuri",
  "block.minecraft.granite_wall": "graniittimuuri",
  "block.minecraft.stone_brick_wall": "kivitiilimuuri",
  "block.minecraft.nether_brick_wall": "nether-tiilimuuri",
  "block.minecraft.andesite_wall": "andesiittimuuri",
  "block.minecraft.red_nether_brick_wall": "punainen nether-tiilimuuri",
  "block.minecraft.sandstone_wall": "hiekkakivimuuri",
  "block.minecraft.end_stone_brick_wall": "end-kivitiilimuuri",
  "block.minecraft.diorite_wall": "dioriittimuuri",
  "block.minecraft.blackstone_wall": "mustakivimuuri",
  "block.minecraft.polished_blackstone_wall": "kiillotettu mustakivimuuri",
  "block.minecraft.polished_blackstone_brick_wall": "kiillotettu mustakivitiilimuuri",
  "block.minecraft.stone_button": "kivinappi",
  "block.minecraft.oak_button": "tamminappi",
  "block.minecraft.spruce_button": "kuusinappi",
  "block.minecraft.birch_button": "koivunappi",
  "block.minecraft.jungle_button": "viidakkopuunappi",
  "block.minecraft.acacia_button": "akaasianappi",
  "block.minecraft.dark_oak_button": "tumma tamminappi",
  "block.minecraft.crimson_button": "karmiininappi",
  "block.minecraft.warped_button": "kummanappi",
  "block.minecraft.polished_blackstone_button": "kiillotettu mustakivinappi",
  "block.minecraft.anvil": "alasin",
  "block.minecraft.chipped_anvil": "kolhiintunut alasin",
  "block.minecraft.damaged_anvil": "vaurioitunut alasin",
  "block.minecraft.trapped_chest": "ansoitettu arkku",
  "block.minecraft.light_weighted_pressure_plate": "kevyt painelaatta",
  "block.minecraft.heavy_weighted_pressure_plate": "painava painelaatta",
  "block.minecraft.daylight_detector": "päivänvalotunnistin",
  "block.minecraft.redstone_block": "redstone-kuutio",
  "block.minecraft.nether_quartz_ore": "nether-kvartsimalmi",
  "block.minecraft.hopper": "suppilo",
  "block.minecraft.chiseled_quartz_block": "kaiverrettu kvartsikuutio",
  "block.minecraft.quartz_block": "kvartsikuutio",
  "block.minecraft.quartz_bricks": "kvartsitiili",
  "block.minecraft.quartz_pillar": "kvartsipilari",
  "block.minecraft.quartz_stairs": "kvartsiportaat",
  "block.minecraft.activator_rail": "aktivointiraide",
  "block.minecraft.dropper": "pudottaja",
  "block.minecraft.white_terracotta": "valkoinen terrakotta",
  "block.minecraft.orange_terracotta": "oranssi terrakotta",
  "block.minecraft.magenta_terracotta": "purppura terrakotta",
  "block.minecraft.light_blue_terracotta": "vaaleansininen terrakotta",
  "block.minecraft.yellow_terracotta": "keltainen terrakotta",
  "block.minecraft.lime_terracotta": "limetinvihreä terrakotta",
  "block.minecraft.pink_terracotta": "vaaleanpunainen terrakotta",
  "block.minecraft.gray_terracotta": "harmaa terrakotta",
  "block.minecraft.light_gray_terracotta": "vaaleanharmaa terrakotta",
  "block.minecraft.cyan_terracotta": "syaani terrakotta",
  "block.minecraft.purple_terracotta": "violetti terrakotta",
  "block.minecraft.blue_terracotta": "sininen terrakotta",
  "block.minecraft.brown_terracotta": "ruskea terrakotta",
  "block.minecraft.green_terracotta": "vihreä terrakotta",
  "block.minecraft.red_terracotta": "punainen terrakotta",
  "block.minecraft.black_terracotta": "musta terrakotta",
  "block.minecraft.barrier": "este",
  "block.minecraft.iron_trapdoor": "rautaluukku",
  "block.minecraft.hay_block": "heinäpaali",
  "block.minecraft.white_carpet": "valkoinen matto",
  "block.minecraft.orange_carpet": "oranssi matto",
  "block.minecraft.magenta_carpet": "purppura matto",
  "block.minecraft.light_blue_carpet": "vaaleansininen matto",
  "block.minecraft.yellow_carpet": "keltainen matto",
  "block.minecraft.lime_carpet": "limetinvihreä matto",
  "block.minecraft.pink_carpet": "vaaleanpunainen matto",
  "block.minecraft.gray_carpet": "harmaa matto",
  "block.minecraft.light_gray_carpet": "vaaleanharmaa matto",
  "block.minecraft.cyan_carpet": "syaani matto",
  "block.minecraft.purple_carpet": "violetti matto",
  "block.minecraft.blue_carpet": "sininen matto",
  "block.minecraft.brown_carpet": "ruskea matto",
  "block.minecraft.green_carpet": "vihreä matto",
  "block.minecraft.red_carpet": "punainen matto",
  "block.minecraft.black_carpet": "musta matto",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "hiilikuutio",
  "block.minecraft.packed_ice": "pakkautunut jää",
  "block.minecraft.acacia_stairs": "akaasiaportaat",
  "block.minecraft.dark_oak_stairs": "tummat tammiportaat",
  "block.minecraft.slime_block": "limakuutio",
  "block.minecraft.grass_path": "ruohopolku",
  "block.minecraft.sunflower": "auringonkukka",
  "block.minecraft.lilac": "syreeni",
  "block.minecraft.rose_bush": "ruusupensas",
  "block.minecraft.peony": "pioni",
  "block.minecraft.tall_grass": "pitkä ruoho",
  "block.minecraft.large_fern": "suuri saniainen",
  "block.minecraft.white_stained_glass": "valkoinen lasi",
  "block.minecraft.orange_stained_glass": "oranssi lasi",
  "block.minecraft.magenta_stained_glass": "purppura lasi",
  "block.minecraft.light_blue_stained_glass": "vaaleansininen lasi",
  "block.minecraft.yellow_stained_glass": "keltainen lasi",
  "block.minecraft.lime_stained_glass": "limetinvihreä lasi",
  "block.minecraft.pink_stained_glass": "vaaleanpunainen lasi",
  "block.minecraft.gray_stained_glass": "harmaa lasi",
  "block.minecraft.light_gray_stained_glass": "vaaleanharmaa lasi",
  "block.minecraft.cyan_stained_glass": "syaani lasi",
  "block.minecraft.purple_stained_glass": "violetti lasi",
  "block.minecraft.blue_stained_glass": "sininen lasi",
  "block.minecraft.brown_stained_glass": "ruskea lasi",
  "block.minecraft.green_stained_glass": "vihreä lasi",
  "block.minecraft.red_stained_glass": "punainen lasi",
  "block.minecraft.black_stained_glass": "musta lasi",
  "block.minecraft.white_stained_glass_pane": "valkoinen lasipaneeli",
  "block.minecraft.orange_stained_glass_pane": "oranssi lasipaneeli",
  "block.minecraft.magenta_stained_glass_pane": "purppura lasipaneeli",
  "block.minecraft.light_blue_stained_glass_pane": "vaaleansininen lasipaneeli",
  "block.minecraft.yellow_stained_glass_pane": "keltainen lasipaneeli",
  "block.minecraft.lime_stained_glass_pane": "limetinvihreä lasipaneeli",
  "block.minecraft.pink_stained_glass_pane": "vaaleanpunainen lasipaneeli",
  "block.minecraft.gray_stained_glass_pane": "harmaa lasipaneeli",
  "block.minecraft.light_gray_stained_glass_pane": "vaaleanharmaa lasipaneeli",
  "block.minecraft.cyan_stained_glass_pane": "syaani lasipaneeli",
  "block.minecraft.purple_stained_glass_pane": "violetti lasipaneeli",
  "block.minecraft.blue_stained_glass_pane": "sininen lasipaneeli",
  "block.minecraft.brown_stained_glass_pane": "ruskea lasipaneeli",
  "block.minecraft.green_stained_glass_pane": "vihreä lasipaneeli",
  "block.minecraft.red_stained_glass_pane": "punainen lasipaneeli",
  "block.minecraft.black_stained_glass_pane": "musta lasipaneeli",
  "block.minecraft.prismarine": "prismariini",
  "block.minecraft.prismarine_bricks": "prismariinitiili",
  "block.minecraft.dark_prismarine": "tumma prismariini",
  "block.minecraft.prismarine_stairs": "prismariiniportaat",
  "block.minecraft.prismarine_brick_stairs": "prismariinitiiliportaat",
  "block.minecraft.dark_prismarine_stairs": "tummat prismariiniportaat",
  "block.minecraft.sea_lantern": "merilyhty",
  "block.minecraft.red_sandstone": "punahiekkakivi",
  "block.minecraft.chiseled_red_sandstone": "kaiverrettu punahiekkakivi",
  "block.minecraft.cut_red_sandstone": "leikattu punahiekkakivi",
  "block.minecraft.red_sandstone_stairs": "punahiekkakiviportaat",
  "block.minecraft.repeating_command_block": "toistava komentokuutio",
  "block.minecraft.chain_command_block": "sarjakomentokuutio",
  "block.minecraft.magma_block": "magmakuutio",
  "block.minecraft.nether_wart_block": "nether-pahkakuutio",
  "block.minecraft.warped_wart_block": "kummapahkakuutio",
  "block.minecraft.red_nether_bricks": "punainen nether-tiili",
  "block.minecraft.bone_block": "luukuutio",
  "block.minecraft.structure_void": "rakennetyhjiö",
  "block.minecraft.observer": "tarkkailija",
  "block.minecraft.shulker_box": "shulker-laatikko",
  "block.minecraft.white_shulker_box": "valkoinen shulker-laatikko",
  "block.minecraft.orange_shulker_box": "oranssi shulker-laatikko",
  "block.minecraft.magenta_shulker_box": "purppura shulker-laatikko",
  "block.minecraft.light_blue_shulker_box": "vaaleansininen shulker-laatikko",
  "block.minecraft.yellow_shulker_box": "keltainen shulker-laatikko",
  "block.minecraft.lime_shulker_box": "limetinvihreä shulker-laatikko",
  "block.minecraft.pink_shulker_box": "vaaleanpunainen shulker-laatikko",
  "block.minecraft.gray_shulker_box": "harmaa shulker-laatikko",
  "block.minecraft.light_gray_shulker_box": "vaaleanharmaa shulker-laatikko",
  "block.minecraft.cyan_shulker_box": "syaani shulker-laatikko",
  "block.minecraft.purple_shulker_box": "violetti shulker-laatikko",
  "block.minecraft.blue_shulker_box": "sininen shulker-laatikko",
  "block.minecraft.brown_shulker_box": "ruskea shulker-laatikko",
  "block.minecraft.green_shulker_box": "vihreä shulker-laatikko",
  "block.minecraft.red_shulker_box": "punainen shulker-laatikko",
  "block.minecraft.black_shulker_box": "musta shulker-laatikko",
  "block.minecraft.white_glazed_terracotta": "valkoinen lasitettu terrakotta",
  "block.minecraft.orange_glazed_terracotta": "oranssi lasitettu terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "purppura lasitettu terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "vaaleansininen lasitettu terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "keltainen lasitettu terrakotta",
  "block.minecraft.lime_glazed_terracotta": "limetinvihreä lasitettu terrakotta",
  "block.minecraft.pink_glazed_terracotta": "vaaleanpunainen lasitettu terrakotta",
  "block.minecraft.gray_glazed_terracotta": "harmaa lasitettu terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "vaaleanharmaa lasitettu terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "syaani lasitettu terrakotta",
  "block.minecraft.purple_glazed_terracotta": "violetti lasitettu terrakotta",
  "block.minecraft.blue_glazed_terracotta": "sininen lasitettu terrakotta",
  "block.minecraft.brown_glazed_terracotta": "ruskea lasitettu terrakotta",
  "block.minecraft.green_glazed_terracotta": "vihreä lasitettu terrakotta",
  "block.minecraft.red_glazed_terracotta": "punainen lasitettu terrakotta",
  "block.minecraft.black_glazed_terracotta": "musta lasitettu terrakotta",
  "block.minecraft.white_concrete": "valkoinen betoni",
  "block.minecraft.orange_concrete": "oranssi betoni",
  "block.minecraft.magenta_concrete": "purppura betoni",
  "block.minecraft.light_blue_concrete": "vaaleansininen betoni",
  "block.minecraft.yellow_concrete": "keltainen betoni",
  "block.minecraft.lime_concrete": "limetinvihreä betoni",
  "block.minecraft.pink_concrete": "vaaleanpunainen betoni",
  "block.minecraft.gray_concrete": "harmaa betoni",
  "block.minecraft.light_gray_concrete": "vaaleanharmaa betoni",
  "block.minecraft.cyan_concrete": "syaani betoni",
  "block.minecraft.purple_concrete": "violetti betoni",
  "block.minecraft.blue_concrete": "sininen betoni",
  "block.minecraft.brown_concrete": "ruskea betoni",
  "block.minecraft.green_concrete": "vihreä betoni",
  "block.minecraft.red_concrete": "punainen betoni",
  "block.minecraft.black_concrete": "musta betoni",
  "block.minecraft.white_concrete_powder": "valkoinen betonijauhe",
  "block.minecraft.orange_concrete_powder": "oranssi betonijauhe",
  "block.minecraft.magenta_concrete_powder": "purppura betonijauhe",
  "block.minecraft.light_blue_concrete_powder": "vaaleansininen betonijauhe",
  "block.minecraft.yellow_concrete_powder": "keltainen betonijauhe",
  "block.minecraft.lime_concrete_powder": "limetinvihreä betonijauhe",
  "block.minecraft.pink_concrete_powder": "vaaleanpunainen betonijauhe",
  "block.minecraft.gray_concrete_powder": "harmaa betonijauhe",
  "block.minecraft.light_gray_concrete_powder": "vaaleanharmaa betonijauhe",
  "block.minecraft.cyan_concrete_powder": "syaani betonijauhe",
  "block.minecraft.purple_concrete_powder": "violetti betonijauhe",
  "block.minecraft.blue_concrete_powder": "sininen betonijauhe",
  "block.minecraft.brown_concrete_powder": "ruskea betonijauhe",
  "block.minecraft.green_concrete_powder": "vihreä betonijauhe",
  "block.minecraft.red_concrete_powder": "punainen betonijauhe",
  "block.minecraft.black_concrete_powder": "musta betonijauhe",
  "block.minecraft.turtle_egg": "kilpikonnan muna",
  "block.minecraft.dead_tube_coral_block": "kuollut putkikorallikuutio",
  "block.minecraft.dead_brain_coral_block": "kuollut aivokorallikuutio",
  "block.minecraft.dead_bubble_coral_block": "kuollut kuplakorallikuutio",
  "block.minecraft.dead_fire_coral_block": "kuollut tulikorallikuutio",
  "block.minecraft.dead_horn_coral_block": "kuollut torvikorallikuutio",
  "block.minecraft.tube_coral_block": "putkikorallikuutio",
  "block.minecraft.brain_coral_block": "aivokorallikuutio",
  "block.minecraft.bubble_coral_block": "kuplakorallikuutio",
  "block.minecraft.fire_coral_block": "tulikorallikuutio",
  "block.minecraft.horn_coral_block": "torvikorallikuutio",
  "block.minecraft.tube_coral": "putkikoralli",
  "block.minecraft.brain_coral": "aivokoralli",
  "block.minecraft.bubble_coral": "kuplakoralli",
  "block.minecraft.fire_coral": "tulikoralli",
  "block.minecraft.horn_coral": "torvikoralli",
  "block.minecraft.dead_brain_coral": "kuollut aivokoralli",
  "block.minecraft.dead_bubble_coral": "kuollut kuplakoralli",
  "block.minecraft.dead_fire_coral": "kuollut tulikoralli",
  "block.minecraft.dead_horn_coral": "kuollut torvikoralli",
  "block.minecraft.dead_tube_coral": "kuollut putkikoralli",
  "block.minecraft.tube_coral_fan": "putkikoralliviuhka",
  "block.minecraft.brain_coral_fan": "aivokoralliviuhka",
  "block.minecraft.bubble_coral_fan": "kuplakoralliviuhka",
  "block.minecraft.fire_coral_fan": "tulikoralliviuhka",
  "block.minecraft.horn_coral_fan": "torvikoralliviuhka",
  "block.minecraft.dead_tube_coral_fan": "kuollut putkikoralliviuhka",
  "block.minecraft.dead_brain_coral_fan": "kuollut aivokoralliviuhka",
  "block.minecraft.dead_bubble_coral_fan": "kuollut kuplakoralliviuhka",
  "block.minecraft.dead_fire_coral_fan": "kuollut tulikoralliviuhka",
  "block.minecraft.dead_horn_coral_fan": "kuollut torvikoralliviuhka",
  "block.minecraft.blue_ice": "sininen jää",
  "block.minecraft.conduit": "kanavoija",
  "block.minecraft.polished_granite_stairs": "kiillotetut graniittiportaat",
  "block.minecraft.smooth_red_sandstone_stairs": "sileät punahiekkakiviportaat",
  "block.minecraft.mossy_stone_brick_stairs": "sammaleiset kivitiiliportaat",
  "block.minecraft.polished_diorite_stairs": "kiillotetut dioriittiportaat",
  "block.minecraft.mossy_cobblestone_stairs": "sammaleiset mukulakiviportaat",
  "block.minecraft.end_stone_brick_stairs": "end-kivitiiliportaat",
  "block.minecraft.stone_stairs": "kiviportaat",
  "block.minecraft.smooth_sandstone_stairs": "sileät hiekkakiviportaat",
  "block.minecraft.smooth_quartz_stairs": "sileät kvartsiportaat",
  "block.minecraft.granite_stairs": "graniittiportaat",
  "block.minecraft.andesite_stairs": "andesiittiportaat",
  "block.minecraft.red_nether_brick_stairs": "punaiset nether-tiiliportaat",
  "block.minecraft.polished_andesite_stairs": "sileät andesiittiportaat",
  "block.minecraft.diorite_stairs": "dioriittiportaat",
  "block.minecraft.polished_granite_slab": "kiillotettu graniittilaatta",
  "block.minecraft.smooth_red_sandstone_slab": "sileä punahiekkakivilaatta",
  "block.minecraft.mossy_stone_brick_slab": "sammaleinen kivitiililaatta",
  "block.minecraft.polished_diorite_slab": "kiillotettu dioriittilaatta",
  "block.minecraft.mossy_cobblestone_slab": "sammaleinen mukulakivilaatta",
  "block.minecraft.end_stone_brick_slab": "end-kivitiililaatta",
  "block.minecraft.smooth_sandstone_slab": "sileä hiekkakivilaatta",
  "block.minecraft.smooth_quartz_slab": "sileä kvartsilaatta",
  "block.minecraft.granite_slab": "graniittilaatta",
  "block.minecraft.andesite_slab": "andesiittilaatta",
  "block.minecraft.red_nether_brick_slab": "punainen nether-tiililaatta",
  "block.minecraft.polished_andesite_slab": "kiillotettu andesiittilaatta",
  "block.minecraft.diorite_slab": "dioriittilaatta",
  "block.minecraft.scaffolding": "rakennusteline",
  "block.minecraft.iron_door": "rautaovi",
  "block.minecraft.oak_door": "tammiovi",
  "block.minecraft.spruce_door": "kuusiovi",
  "block.minecraft.birch_door": "koivuovi",
  "block.minecraft.jungle_door": "viidakkopuuovi",
  "block.minecraft.acacia_door": "akaasiaovi",
  "block.minecraft.dark_oak_door": "tumma tammiovi",
  "block.minecraft.crimson_door": "karmiiniovi",
  "block.minecraft.warped_door": "kummaovi",
  "block.minecraft.repeater": "redstone-toistin",
  "block.minecraft.comparator": "redstone-komparaattori",
  "block.minecraft.structure_block": "rakennekuutio",
  "block.minecraft.jigsaw": "palapelikuutio",
  "item.minecraft.turtle_helmet": "kilpikonnan kuori□□kun päässä:□+2 haarniska",
  "item.minecraft.scute": "kilvenpalanen",
  "item.minecraft.iron_shovel": "rautalapio□□kun pääkädessä:□+3.5 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.iron_pickaxe": "rautahakku□□kun pääkädessä:□+3 hyökkäysvahinko□-2.8 hyökkäysnopeus",
  "item.minecraft.iron_axe": "rautakirves□□kun pääkädessä:□+8 hyökkäysvahinko□-3.1 hyökkäysnopeus",
  "item.minecraft.flint_and_steel": "tulukset",
  "item.minecraft.apple": "omena",
  "item.minecraft.bow": "jousi",
  "item.minecraft.arrow": "nuoli",
  "item.minecraft.coal": "hiili",
  "item.minecraft.charcoal": "puuhiili",
  "item.minecraft.diamond": "timantti",
  "item.minecraft.iron_ingot": "rautaharkko",
  "item.minecraft.gold_ingot": "kultaharkko",
  "item.minecraft.netherite_ingot": "netheriittiharkko",
  "item.minecraft.netherite_scrap": "netheriittiromu",
  "item.minecraft.iron_sword": "rautamiekka□□kun pääkädessä:□+5 hyökkäysvahinko□-2.4 hyökkäysnopeus",
  "item.minecraft.wooden_sword": "puumiekka□□kun pääkädessä:□+3 hyökkäysvahinko□-2.4 hyökkäysnopeus",
  "item.minecraft.wooden_shovel": "puulapio□□kun pääkädessä:□+1.5 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.wooden_pickaxe": "puuhakku□□kun pääkädessä:□+1 hyökkäysvahinko□-2.8 hyökkäysnopeus",
  "item.minecraft.wooden_axe": "puukirves□□kun pääkädessä:□+6 hyökkäysvahinko□-3.2 hyökkäysnopeus",
  "item.minecraft.stone_sword": "kivimiekka□□kun pääkädessä:□+4 hyökkäysvahinko□-2.4 hyökkäysnopeus",
  "item.minecraft.stone_shovel": "kivilapio□□kun pääkädessä:□+2.5 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.stone_pickaxe": "kivihakku□□kun pääkädessä:□+2 hyökkäysvahinko□-2.8 hyökkäysnopeus",
  "item.minecraft.stone_axe": "kivikirves□□kun pääkädessä:□+8 hyökkäysvahinko□-3.2 hyökkäysnopeus",
  "item.minecraft.diamond_sword": "timanttimiekka□□kun pääkädessä:□+6 hyökkäysvahinko□-2.4 hyökkäysnopeus",
  "item.minecraft.diamond_shovel": "timanttilapio□□kun pääkädessä:□+4.5 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.diamond_pickaxe": "timanttihakku□□kun pääkädessä:□+4 hyökkäysvahinko□-2.8 hyökkäysnopeus",
  "item.minecraft.diamond_axe": "timanttikirves□□kun pääkädessä:□+8 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.stick": "keppi",
  "item.minecraft.bowl": "kulho",
  "item.minecraft.mushroom_stew": "sienimuhennos",
  "item.minecraft.golden_sword": "kultamiekka□□kun pääkädessä:□+3 hyökkäysvahinko□-2.4 hyökkäysnopeus",
  "item.minecraft.golden_shovel": "kultalapio□□kun pääkädessä:□+1.5 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.golden_pickaxe": "kultahakku□□kun pääkädessä:□+1 hyökkäysvahinko□-2.8 hyökkäysnopeus",
  "item.minecraft.golden_axe": "kultakirves□□kun pääkädessä:□+6 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.netherite_sword": "netheriittimiekka□□kun pääkädessä:□+7 hyökkäysvahinko□-2.4 hyökkäysnopeus",
  "item.minecraft.netherite_shovel": "netheriittilapio□□kun pääkädessä:□+5.5 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.netherite_pickaxe": "netheriittihakku□□kun pääkädessä:□+5 hyökkäysvahinko□-2.8 hyökkäysnopeus",
  "item.minecraft.netherite_axe": "netheriittikirves□□kun pääkädessä:□+9 hyökkäysvahinko□-3 hyökkäysnopeus",
  "item.minecraft.string": "lanka",
  "item.minecraft.feather": "höyhen",
  "item.minecraft.gunpowder": "ruuti",
  "item.minecraft.wooden_hoe": "puukuokka□□kun pääkädessä:□-3 hyökkäysnopeus",
  "item.minecraft.stone_hoe": "kivikuokka□□kun pääkädessä:□-2 hyökkäysnopeus",
  "item.minecraft.iron_hoe": "rautakuokka□□kun pääkädessä:□-1 hyökkäysnopeus",
  "item.minecraft.diamond_hoe": "timanttikuokka□□kun pääkädessä:",
  "item.minecraft.golden_hoe": "kultakuokka□□kun pääkädessä:□-3 hyökkäysnopeus",
  "item.minecraft.netherite_hoe": "netheriittikuokka□□kun pääkädessä:",
  "item.minecraft.wheat_seeds": "vehnän siemenet",
  "item.minecraft.wheat": "vehnä",
  "item.minecraft.bread": "leipä",
  "item.minecraft.leather_helmet": "nahkalakki□□kun päässä:□+1 haarniska",
  "item.minecraft.leather_chestplate": "nahkatakki□□kun kehossa:□+3 haarniska",
  "item.minecraft.leather_leggings": "nahkahousut□□kun jalkavarsissa:□+2 haarniska",
  "item.minecraft.leather_boots": "nahkasaappaat□□kun jaloissa:□+1 haarniska",
  "item.minecraft.chainmail_helmet": "rengashaarniskan kypärä□□kun päässä:□+2 haarniska",
  "item.minecraft.chainmail_chestplate": "rengashaarniskan rintapanssari□□kun kehossa:□+5 haarniska",
  "item.minecraft.chainmail_leggings": "rengashaarniskan housut□□kun jalkavarsissa:□+4 haarniska",
  "item.minecraft.chainmail_boots": "rengashaarniskan kengät□□kun jaloissa:□+1 haarniska",
  "item.minecraft.iron_helmet": "rautakypärä□□kun päässä:□+2 haarniska",
  "item.minecraft.iron_chestplate": "rautarintapanssari□□kun kehossa:□+6 haarniska",
  "item.minecraft.iron_leggings": "rautahousut□□kun jalkavarsissa:□+5 haarniska",
  "item.minecraft.iron_boots": "rautasaappaat□□kun jaloissa:□+2 haarniska",
  "item.minecraft.diamond_helmet": "timanttikypärä□□kun päässä:□+3 haarniska□+2 haarniskan kovuus",
  "item.minecraft.diamond_chestplate": "timanttirintapanssari□□kun kehossa:□+8 haarniska□+2 haarniskan kovuus",
  "item.minecraft.diamond_leggings": "timanttihousut□□kun jalkavarsissa:□+6 haarniska□+2 haarniskan kovuus",
  "item.minecraft.diamond_boots": "timanttisaappaat□□kun jaloissa:□+3 haarniska□+2 haarniskan kovuus",
  "item.minecraft.golden_helmet": "kultakypärä□□kun päässä:□+2 haarniska",
  "item.minecraft.golden_chestplate": "kultarintapanssari□□kun kehossa:□+5 haarniska",
  "item.minecraft.golden_leggings": "kultahousut□□kun jalkavarsissa:□+3 haarniska",
  "item.minecraft.golden_boots": "kultasaappaat□□kun jaloissa:□+1 haarniska",
  "item.minecraft.netherite_helmet": "netheriittikypärä□□kun päässä:□+3 haarniska□+3 haarniskan kovuus□+1 taakselyönnin vastustaminen",
  "item.minecraft.netherite_chestplate": "netheriittirintapanssari□□kun kehossa:□+8 haarniska□+3 haarniskan kovuus□+1 taakselyönnin vastustaminen",
  "item.minecraft.netherite_leggings": "netheriittihousut□□kun jalkavarsissa:□+6 haarniska□+3 haarniskan kovuus□+1 taakselyönnin vastustaminen",
  "item.minecraft.netherite_boots": "netheriittisaappaat□□kun jaloissa:□+3 haarniska□+3 haarniskan kovuus□+1 taakselyönnin vastustaminen",
  "item.minecraft.flint": "piikivi",
  "item.minecraft.porkchop": "raaka porsaankyljys",
  "item.minecraft.cooked_porkchop": "paistettu porsaankyljys",
  "item.minecraft.painting": "maalaus",
  "item.minecraft.golden_apple": "kultaomena",
  "item.minecraft.enchanted_golden_apple": "lumottu kultaomena",
  "block.minecraft.oak_sign": "tammikyltti",
  "block.minecraft.spruce_sign": "kuusikyltti",
  "block.minecraft.birch_sign": "koivukyltti",
  "block.minecraft.jungle_sign": "viidakkopuukyltti",
  "block.minecraft.acacia_sign": "akaasiakyltti",
  "block.minecraft.dark_oak_sign": "tumma tammikyltti",
  "block.minecraft.crimson_sign": "karmiinikyltti",
  "block.minecraft.warped_sign": "kummakyltti",
  "item.minecraft.bucket": "ämpäri",
  "item.minecraft.water_bucket": "vesiämpäri",
  "item.minecraft.lava_bucket": "laavaämpäri",
  "item.minecraft.minecart": "kaivosvaunu",
  "item.minecraft.saddle": "satula",
  "item.minecraft.redstone": "redstone-jauhe",
  "item.minecraft.snowball": "lumipallo",
  "item.minecraft.oak_boat": "tammivene",
  "item.minecraft.leather": "nahka",
  "item.minecraft.milk_bucket": "maitoämpäri",
  "item.minecraft.pufferfish_bucket": "pallokala ämpärissä",
  "item.minecraft.salmon_bucket": "lohi ämpärissä",
  "item.minecraft.cod_bucket": "turska ämpärissä",
  "item.minecraft.tropical_fish_bucket": "trooppinen kala ämpärissä",
  "item.minecraft.brick": "tiili",
  "item.minecraft.clay_ball": "savipallo",
  "block.minecraft.dried_kelp_block": "kuivattu rakkoleväkuutio",
  "item.minecraft.paper": "paperi",
  "item.minecraft.book": "kirja",
  "item.minecraft.slime_ball": "limapallo",
  "item.minecraft.chest_minecart": "arkullinen kaivosvaunu",
  "item.minecraft.furnace_minecart": "moottoroitu kaivosvaunu",
  "item.minecraft.egg": "kananmuna",
  "item.minecraft.compass": "kompassi",
  "item.minecraft.fishing_rod": "onkivapa",
  "item.minecraft.clock": "kello",
  "item.minecraft.glowstone_dust": "hehkukivijauhe",
  "item.minecraft.cod": "raaka turska",
  "item.minecraft.salmon": "raaka lohi",
  "item.minecraft.tropical_fish": "trooppinen kala",
  "item.minecraft.pufferfish": "pallokala",
  "item.minecraft.cooked_cod": "paistettu turska",
  "item.minecraft.cooked_salmon": "paistettu lohi",
  "item.minecraft.ink_sac": "mustepussi",
  "item.minecraft.red_dye": "punainen väriaine",
  "item.minecraft.green_dye": "vihreä väriaine",
  "item.minecraft.cocoa_beans": "kaakaopavut",
  "item.minecraft.lapis_lazuli": "lasuriitti",
  "item.minecraft.purple_dye": "violetti väriaine",
  "item.minecraft.cyan_dye": "syaani väriaine",
  "item.minecraft.light_gray_dye": "vaaleanharmaa väriaine",
  "item.minecraft.gray_dye": "harmaa väriaine",
  "item.minecraft.pink_dye": "vaaleanpunainen väriaine",
  "item.minecraft.lime_dye": "limetinvihreä väriaine",
  "item.minecraft.yellow_dye": "keltainen väriaine",
  "item.minecraft.light_blue_dye": "vaaleansininen väriaine",
  "item.minecraft.magenta_dye": "purppura väriaine",
  "item.minecraft.orange_dye": "oranssi väriaine",
  "item.minecraft.bone_meal": "luujauho",
  "item.minecraft.blue_dye": "sininen väriaine",
  "item.minecraft.brown_dye": "ruskea väriaine",
  "item.minecraft.black_dye": "musta väriaine",
  "item.minecraft.white_dye": "valkoinen väriaine",
  "item.minecraft.bone": "luu",
  "item.minecraft.sugar": "sokeri",
  "block.minecraft.cake": "kakku",
  "block.minecraft.white_bed": "valkoinen sänky",
  "block.minecraft.orange_bed": "oranssi sänky",
  "block.minecraft.magenta_bed": "purppura sänky",
  "block.minecraft.light_blue_bed": "vaaleansininen sänky",
  "block.minecraft.yellow_bed": "keltainen sänky",
  "block.minecraft.lime_bed": "limetinvihreä sänky",
  "block.minecraft.pink_bed": "vaaleanpunainen sänky",
  "block.minecraft.gray_bed": "harmaa sänky",
  "block.minecraft.light_gray_bed": "vaaleanharmaa sänky",
  "block.minecraft.cyan_bed": "syaani sänky",
  "block.minecraft.purple_bed": "violetti sänky",
  "block.minecraft.blue_bed": "sininen sänky",
  "block.minecraft.brown_bed": "ruskea sänky",
  "block.minecraft.green_bed": "vihreä sänky",
  "block.minecraft.red_bed": "punainen sänky",
  "block.minecraft.black_bed": "musta sänky",
  "item.minecraft.cookie": "keksi",
  "item.minecraft.filled_map": "kartta□#0",
  "item.minecraft.shears": "keritsimet",
  "item.minecraft.melon_slice": "melonin siivu",
  "item.minecraft.dried_kelp": "kuivattu rakkolevä",
  "item.minecraft.pumpkin_seeds": "kurpitsan siemenet",
  "item.minecraft.melon_seeds": "melonin siemenet",
  "item.minecraft.beef": "raaka pihvi",
  "item.minecraft.cooked_beef": "paisti",
  "item.minecraft.chicken": "raaka kana",
  "item.minecraft.cooked_chicken": "paistettu kana",
  "item.minecraft.rotten_flesh": "mädäntynyt liha",
  "item.minecraft.ender_pearl": "ender-helmi",
  "item.minecraft.blaze_rod": "roihusauva",
  "item.minecraft.ghast_tear": "ghastin kyynel",
  "item.minecraft.gold_nugget": "kultahippu",
  "item.minecraft.nether_wart": "nether-pahka",
  "item.minecraft.potion": "valmistuskelvoton taikajuoma□ei vaikutuksia",
  "item.minecraft.glass_bottle": "lasipullo",
  "item.minecraft.spider_eye": "hämähäkinsilmä",
  "item.minecraft.fermented_spider_eye": "käynyt hämähäkinsilmä",
  "item.minecraft.blaze_powder": "roihujauhe",
  "item.minecraft.magma_cream": "magmavoide",
  "block.minecraft.brewing_stand": "hautumateline",
  "block.minecraft.cauldron": "pata",
  "item.minecraft.ender_eye": "ender-silmä",
  "item.minecraft.glistering_melon_slice": "kimalteleva melonin siivu",
  "item.minecraft.bat_spawn_egg": "luo lepakko",
  "item.minecraft.bee_spawn_egg": "luo mehiläinen",
  "item.minecraft.blaze_spawn_egg": "luo roihu",
  "item.minecraft.cat_spawn_egg": "luo kissa",
  "item.minecraft.cave_spider_spawn_egg": "luo luolahämähäkki",
  "item.minecraft.chicken_spawn_egg": "luo kana",
  "item.minecraft.cod_spawn_egg": "luo turska",
  "item.minecraft.cow_spawn_egg": "luo lehmä",
  "item.minecraft.creeper_spawn_egg": "luo creeper",
  "item.minecraft.dolphin_spawn_egg": "luo delfiini",
  "item.minecraft.donkey_spawn_egg": "luo aasi",
  "item.minecraft.drowned_spawn_egg": "luo hukkunut",
  "item.minecraft.elder_guardian_spawn_egg": "luo vartijavanhin",
  "item.minecraft.enderman_spawn_egg": "luo enderman",
  "item.minecraft.endermite_spawn_egg": "luo endermite",
  "item.minecraft.evoker_spawn_egg": "luo manaaja",
  "item.minecraft.fox_spawn_egg": "luo kettu",
  "item.minecraft.ghast_spawn_egg": "luo ghast",
  "item.minecraft.guardian_spawn_egg": "luo vartija",
  "item.minecraft.hoglin_spawn_egg": "luo hoglin",
  "item.minecraft.horse_spawn_egg": "luo hevonen",
  "item.minecraft.husk_spawn_egg": "luo holkki",
  "item.minecraft.llama_spawn_egg": "luo laama",
  "item.minecraft.magma_cube_spawn_egg": "luo magmakuutio",
  "item.minecraft.mooshroom_spawn_egg": "luo mooshroom",
  "item.minecraft.mule_spawn_egg": "luo muuli",
  "item.minecraft.ocelot_spawn_egg": "luo oselotti",
  "item.minecraft.panda_spawn_egg": "luo panda",
  "item.minecraft.parrot_spawn_egg": "luo papukaija",
  "item.minecraft.phantom_spawn_egg": "luo aave",
  "item.minecraft.pig_spawn_egg": "luo sika",
  "item.minecraft.piglin_spawn_egg": "luo piglin",
  "item.minecraft.pillager_spawn_egg": "luo ryöstäjä",
  "item.minecraft.polar_bear_spawn_egg": "luo jääkarhu",
  "item.minecraft.pufferfish_spawn_egg": "luo pallokala",
  "item.minecraft.rabbit_spawn_egg": "luo jänis",
  "item.minecraft.ravager_spawn_egg": "luo raunioittaja",
  "item.minecraft.salmon_spawn_egg": "luo lohi",
  "item.minecraft.sheep_spawn_egg": "luo lammas",
  "item.minecraft.shulker_spawn_egg": "luo shulker",
  "item.minecraft.silverfish_spawn_egg": "luo sokeritoukka",
  "item.minecraft.skeleton_spawn_egg": "luo luuranko",
  "item.minecraft.skeleton_horse_spawn_egg": "luo luurankohevonen",
  "item.minecraft.slime_spawn_egg": "luo lima",
  "item.minecraft.spider_spawn_egg": "luo hämähäkki",
  "item.minecraft.squid_spawn_egg": "luo kalmari",
  "item.minecraft.stray_spawn_egg": "luo vaeltaja",
  "item.minecraft.strider_spawn_egg": "luo rämpijä",
  "item.minecraft.trader_llama_spawn_egg": "luo kulkukauppiaan laama",
  "item.minecraft.tropical_fish_spawn_egg": "luo trooppinen kala",
  "item.minecraft.turtle_spawn_egg": "luo kilpikonna",
  "item.minecraft.vex_spawn_egg": "luo piina",
  "item.minecraft.villager_spawn_egg": "luo kyläläinen",
  "item.minecraft.vindicator_spawn_egg": "luo puhdistaja",
  "item.minecraft.wandering_trader_spawn_egg": "luo kulkukauppias",
  "item.minecraft.witch_spawn_egg": "luo noita",
  "item.minecraft.wither_skeleton_spawn_egg": "luo wither-luuranko",
  "item.minecraft.wolf_spawn_egg": "luo susi",
  "item.minecraft.zoglin_spawn_egg": "luo zoglin",
  "item.minecraft.zombie_spawn_egg": "luo zombi",
  "item.minecraft.zombie_horse_spawn_egg": "luo zombihevonen",
  "item.minecraft.zombie_villager_spawn_egg": "luo zombikyläläinen",
  "item.minecraft.zombified_piglin_spawn_egg": "luo zombipiglin",
  "item.minecraft.experience_bottle": "lumottu pullo",
  "item.minecraft.fire_charge": "tulipallo",
  "item.minecraft.writable_book": "kirja ja sulkakynä",
  "item.minecraft.written_book": "kirjoitettu kirja",
  "item.minecraft.emerald": "smaragdi",
  "item.minecraft.item_frame": "kehys",
  "block.minecraft.flower_pot": "kukkaruukku",
  "item.minecraft.carrot": "porkkana",
  "item.minecraft.potato": "peruna",
  "item.minecraft.baked_potato": "paistettu peruna",
  "item.minecraft.poisonous_potato": "myrkyllinen peruna",
  "item.minecraft.map": "tyhjä kartta",
  "item.minecraft.golden_carrot": "kultaporkkana",
  "block.minecraft.skeleton_skull": "luurangon kallo",
  "block.minecraft.wither_skeleton_skull": "wither-luurangon kallo",
  "block.minecraft.player_head": "pelaajan pää",
  "block.minecraft.zombie_head": "zombin pää",
  "block.minecraft.creeper_head": "creeperin pää",
  "block.minecraft.dragon_head": "lohikäärmeen pää",
  "item.minecraft.carrot_on_a_stick": "porkkana kepin päässä",
  "item.minecraft.warped_fungus_on_a_stick": "kummasieni kepin päässä",
  "item.minecraft.nether_star": "nether-tähti",
  "item.minecraft.pumpkin_pie": "kurpitsapiirakka",
  "item.minecraft.firework_rocket": "ilotulitusraketti",
  "item.minecraft.firework_star": "ilotulituspanos",
  "item.minecraft.enchanted_book": "lumottu kirja",
  "item.minecraft.nether_brick": "nether-tiili",
  "item.minecraft.quartz": "nether-kvartsi",
  "item.minecraft.tnt_minecart": "tnt-kaivosvaunu",
  "item.minecraft.hopper_minecart": "suppilokaivosvaunu",
  "item.minecraft.prismarine_shard": "prismariinisirpale",
  "item.minecraft.prismarine_crystals": "prismariinikristallit",
  "item.minecraft.rabbit": "raaka jäniksenliha",
  "item.minecraft.cooked_rabbit": "paistettu jäniksenliha",
  "item.minecraft.rabbit_stew": "jänismuhennos",
  "item.minecraft.rabbit_foot": "jäniksenkäpälä",
  "item.minecraft.rabbit_hide": "jäniksen nahka",
  "item.minecraft.armor_stand": "haarniskateline",
  "item.minecraft.iron_horse_armor": "rautainen hevosen panssari",
  "item.minecraft.golden_horse_armor": "kultainen hevosen panssari",
  "item.minecraft.diamond_horse_armor": "timanttinen hevosen panssari",
  "item.minecraft.leather_horse_armor": "nahkainen hevosen panssari",
  "item.minecraft.lead": "talutushihna",
  "item.minecraft.name_tag": "nimilappu",
  "item.minecraft.command_block_minecart": "komentokuutiokaivosvaunu",
  "item.minecraft.mutton": "raaka lampaanliha",
  "item.minecraft.cooked_mutton": "paistettu lampaanliha",
  "block.minecraft.white_banner": "valkoinen viiri",
  "block.minecraft.orange_banner": "oranssi viiri",
  "block.minecraft.magenta_banner": "purppura viiri",
  "block.minecraft.light_blue_banner": "vaaleansininen viiri",
  "block.minecraft.yellow_banner": "keltainen viiri",
  "block.minecraft.lime_banner": "limetinvihreä viiri",
  "block.minecraft.pink_banner": "vaaleanpunainen viiri",
  "block.minecraft.gray_banner": "harmaa viiri",
  "block.minecraft.light_gray_banner": "vaaleanharmaa viiri",
  "block.minecraft.cyan_banner": "syaani viiri",
  "block.minecraft.purple_banner": "violetti viiri",
  "block.minecraft.blue_banner": "sininen viiri",
  "block.minecraft.brown_banner": "ruskea viiri",
  "block.minecraft.green_banner": "vihreä viiri",
  "block.minecraft.red_banner": "punainen viiri",
  "block.minecraft.black_banner": "musta viiri",
  "item.minecraft.end_crystal": "end-kristalli",
  "item.minecraft.chorus_fruit": "chorus-hedelmä",
  "item.minecraft.popped_chorus_fruit": "paistettu chorus-hedelmä",
  "item.minecraft.beetroot": "punajuuri",
  "item.minecraft.beetroot_seeds": "punajuuren siemenet",
  "item.minecraft.beetroot_soup": "punajuurikeitto",
  "item.minecraft.dragon_breath": "lohikäärmeen henkäys",
  "item.minecraft.splash_potion": "roiskahtava valmistuskelvoton taikajuoma□ei vaikutuksia",
  "item.minecraft.spectral_arrow": "spektraalinuoli",
  "item.minecraft.tipped_arrow": "valmistuskelvoton kastettu nuoli□ei vaikutuksia",
  "item.minecraft.lingering_potion": "valmistuskelvoton viipyvä taikajuoma□ei vaikutuksia",
  "item.minecraft.shield": "kilpi",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "kuusivene",
  "item.minecraft.birch_boat": "koivuvene",
  "item.minecraft.jungle_boat": "viidakkopuuvene",
  "item.minecraft.acacia_boat": "akaasiavene",
  "item.minecraft.dark_oak_boat": "tumma tammivene",
  "item.minecraft.totem_of_undying": "kuolemattomuuden toteemi",
  "item.minecraft.shulker_shell": "shulkerin kuori",
  "item.minecraft.iron_nugget": "rautakimpale",
  "item.minecraft.knowledge_book": "tietokirja",
  "item.minecraft.debug_stick": "virheenkorjaustikku",
  "item.minecraft.music_disc_13": "musiikkilevy□c418 - 13",
  "item.minecraft.music_disc_cat": "musiikkilevy□c418 - cat",
  "item.minecraft.music_disc_blocks": "musiikkilevy□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musiikkilevy□c418 - chirp",
  "item.minecraft.music_disc_far": "musiikkilevy□c418 - far",
  "item.minecraft.music_disc_mall": "musiikkilevy□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musiikkilevy□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musiikkilevy□c418 - stal",
  "item.minecraft.music_disc_strad": "musiikkilevy□c418 - strad",
  "item.minecraft.music_disc_ward": "musiikkilevy□c418 - ward",
  "item.minecraft.music_disc_11": "musiikkilevy□c418 - 11",
  "item.minecraft.music_disc_wait": "musiikkilevy□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musiikkilevy□lena raine - pigstep",
  "item.minecraft.trident": "atrain□□kun pääkädessä:□+8 hyökkäysvahinko□-2.9 hyökkäysnopeus",
  "item.minecraft.phantom_membrane": "aaveen kalvo",
  "item.minecraft.nautilus_shell": "helmiveneen kuori",
  "item.minecraft.heart_of_the_sea": "meren sydän",
  "item.minecraft.crossbow": "varsijousi",
  "item.minecraft.suspicious_stew": "epäilyttävä muhennos",
  "block.minecraft.loom": "kangaspuut",
  "item.minecraft.flower_banner_pattern": "viirikuvio□kukkaräjähde",
  "item.minecraft.creeper_banner_pattern": "viirikuvio□creeper-räjähde",
  "item.minecraft.skull_banner_pattern": "viirikuvio□pääkalloräjähde",
  "item.minecraft.mojang_banner_pattern": "viirikuvio□mojang-symboli",
  "item.minecraft.globe_banner_pattern": "viirikuvio□karttakuutio",
  "item.minecraft.piglin_banner_pattern": "viirikuvio□kärsä",
  "block.minecraft.composter": "komposti",
  "block.minecraft.barrel": "tynnyri",
  "block.minecraft.smoker": "savustin",
  "block.minecraft.blast_furnace": "masuuni",
  "block.minecraft.cartography_table": "karttapöytä",
  "block.minecraft.fletching_table": "nuolipöytä",
  "block.minecraft.grindstone": "tahko",
  "block.minecraft.lectern": "kateederi",
  "block.minecraft.smithing_table": "takomispöytä",
  "block.minecraft.stonecutter": "kivileikkuri",
  "block.minecraft.bell": "soittokello",
  "block.minecraft.lantern": "lyhty",
  "block.minecraft.soul_lantern": "sielulyhty",
  "item.minecraft.sweet_berries": "makeat marjat",
  "block.minecraft.campfire": "nuotio",
  "block.minecraft.soul_campfire": "sielunuotio",
  "block.minecraft.shroomlight": "sienivalo",
  "item.minecraft.honeycomb": "hunajakenno",
  "block.minecraft.bee_nest": "luonnollinen mehiläispesä",
  "block.minecraft.beehive": "keinotekoinen mehiläispesä",
  "item.minecraft.honey_bottle": "hunajapullo",
  "block.minecraft.honey_block": "hunajakuutio",
  "block.minecraft.honeycomb_block": "hunajakennokuutio",
  "block.minecraft.lodestone": "magneettikivi",
  "block.minecraft.netherite_block": "netheriittikuutio",
  "block.minecraft.ancient_debris": "muinainen romu",
  "block.minecraft.target": "maalitaulu",
  "block.minecraft.crying_obsidian": "itkevä obsidiaani",
  "block.minecraft.blackstone": "mustakivi",
  "block.minecraft.blackstone_slab": "mustakivilaatta",
  "block.minecraft.blackstone_stairs": "mustakiviportaat",
  "block.minecraft.gilded_blackstone": "kullattu mustakivi",
  "block.minecraft.polished_blackstone": "kiillotettu mustakivi",
  "block.minecraft.polished_blackstone_slab": "kiillotettu mustakivilaatta",
  "block.minecraft.polished_blackstone_stairs": "kiillotetut mustakiviportaat",
  "block.minecraft.chiseled_polished_blackstone": "kaiverrettu kiillotettu mustakivi",
  "block.minecraft.polished_blackstone_bricks": "kiillotettu mustakivitiili",
  "block.minecraft.polished_blackstone_brick_slab": "kiillotettu mustakivitiililaatta",
  "block.minecraft.polished_blackstone_brick_stairs": "kiillotetut mustakivitiiliportaat",
  "block.minecraft.cracked_polished_blackstone_bricks": "murtunut kiillotettu mustakivi",
  "block.minecraft.respawn_anchor": "uudelleensyntymisankkuri",
}
export const fi_fi = items; 
